"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authenticated = exports.SECTION_KEY = void 0;
var tslib_1 = require("tslib");
/* eslint-disable no-console */
var asg_1 = require("@alinta-digital/asg");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var types_1 = require("../../../types");
var components_1 = require("../../../components");
var formik_1 = require("formik");
var utils_1 = (0, tslib_1.__importDefault)(require("../../../components/CreditCard/utils"));
var SavedPaymentTile_1 = (0, tslib_1.__importStar)(require("../../../components/SavedPaymentTile/SavedPaymentTile"));
var PaymentMethodCheckBox_1 = (0, tslib_1.__importDefault)(require("../../../components/PaymentMethodCheckBox"));
var SavedPaymentTile_types_1 = require("../../../components/SavedPaymentTile/SavedPaymentTile.types");
var types_2 = require("@alinta-digital/myaccount-frontend-shared/types");
var PaypalPaymentTile_1 = (0, tslib_1.__importDefault)(require("../../../components/PaypalPaymentTile/PaypalPaymentTile"));
var PaypalPaymentTile_2 = require("../../../components/PaypalPaymentTile/PaypalPaymentTile");
exports.SECTION_KEY = 'paymentDetails';
var Authenticated = function (props) {
    var _a;
    var baseURL = props.baseURL, skipMountingScript = props.skipMountingScript, bamboraURL = props.bamboraURL, guid = props.guid, accountDetails = props.accountDetails, currentStepKey = props.currentStepKey, nextStepKey = props.nextStepKey, onCancel = props.onCancel, onSubmit = props.onSubmit, savedPayment = props.savedPayment, ga = props.ga;
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var _c = (0, react_1.useState)(types_1.PaymentCardType.EMPTY), cardType = _c[0], setCardType = _c[1];
    var _d = (0, react_1.useContext)(asg_1.StepsContext), steps = _d.steps, goToStep = _d.goToStep, completeStep = _d.completeStep;
    var _e = (0, react_1.useState)(true), savedAccountLoading = _e[0], setSavedAccountLoading = _e[1];
    var _f = (0, react_1.useState)(null), instance = _f[0], setInstance = _f[1];
    var appBaseUrl = baseURL ? baseURL : 'https://www.alintaenergy.com.au';
    //loads bambora js script for payment form to work locally
    var ready = (0, utils_1.default)(bamboraURL, skipMountingScript)[0];
    var _g = (0, formik_1.useFormikContext)(), errors = _g.errors, dirty = _g.dirty, values = _g.values, setFieldValue = _g.setFieldValue;
    var _h = (0, react_1.useState)(values.paymentDetails.savedPaymentId ? true : false), isCardValid = _h[0], setIsCardValid = _h[1];
    var _j = (0, react_1.useState)(''), selectedPaymentMethod = _j[0], setSelectedPaymentMethod = _j[1];
    var hasPaymentDetailsError = selectedPaymentMethod === 'card' && ((errors === null || errors === void 0 ? void 0 : errors.paymentDetails) !== undefined || !isCardValid);
    var hasPaymentDetailsCardError = selectedPaymentMethod === SavedPaymentTile_1.ADD_NEW && ((errors === null || errors === void 0 ? void 0 : errors.paymentDetails) !== undefined || !isCardValid);
    var hasPaypalPaymentDetailsError = selectedPaymentMethod === 'paypal' && ((_a = errors === null || errors === void 0 ? void 0 : errors.paymentDetails) === null || _a === void 0 ? void 0 : _a.paymentAmount) !== undefined;
    var _k = (0, react_1.useState)(values.paymentDetails.savedPaymentId ? false : true), goToBambora = _k[0], setGoToBambora = _k[1];
    var _l = (0, react_1.useState)(), savedPaymentCardDetails = _l[0], setSavedPaymentCardDetails = _l[1];
    var _m = (0, react_1.useState)(false), showCC = _m[0], setShowCC = _m[1];
    var _o = (0, react_1.useState)(false), hasSavedPaymentError = _o[0], setSavedPaymentError = _o[1];
    (0, react_1.useEffect)(function () {
        if (window && window.location) {
            var paypalUrl = window.location.search;
            var urlParams = new URLSearchParams(paypalUrl);
            var isPaypalResultPage = (urlParams === null || urlParams === void 0 ? void 0 : urlParams.has('SessionID')) && urlParams.has('SST');
            if (isPaypalResultPage && !steps.step3.isComplete) {
                completeStep(currentStepKey);
                goToStep('step3');
            }
            if (isPaypalResultPage && steps.step3.isComplete) {
                goToStep('step1');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(function () {
        var _a;
        if (ready) {
            if (((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.payment') {
                ga === null || ga === void 0 ? void 0 : ga.push('load.2.cardDetailsPage');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ready]);
    (0, react_1.useEffect)(function () {
        if (ready) {
            if (selectedPaymentMethod === SavedPaymentTile_1.ADD_NEW) {
                setInstance(window.customcheckout());
                setShowCC(true);
            }
            else {
                setShowCC(false);
                setInstance(null);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ready, selectedPaymentMethod]);
    if (ready) {
        return (react_1.default.createElement(components_1.Content, (0, tslib_1.__assign)({}, {
            header: {
                hide: false,
                title: 'Make a payment'
            },
            footer: {
                hide: false,
                leftButton: {
                    label: 'Cancel',
                    disabled: loading ? true : false,
                    onClick: function () {
                        onCancel();
                    }
                },
                rightButton: {
                    label: 'Continue',
                    loading: loading,
                    disabled: dirty === false ||
                        hasPaymentDetailsError ||
                        hasPaypalPaymentDetailsError ||
                        hasPaymentDetailsCardError ||
                        !selectedPaymentMethod,
                    onClick: function (event) {
                        event.preventDefault();
                        setLoading(true);
                        if (goToBambora) {
                            try {
                                instance === null || instance === void 0 ? void 0 : instance.createOneTimeToken(guid, function (result1) {
                                    if (result1.code > 200) {
                                        var savePaymentToken_1 = result1.token;
                                        instance === null || instance === void 0 ? void 0 : instance.createOneTimeToken(guid, function (result2) {
                                            if (result2.code > 200) {
                                                onSubmit((0, tslib_1.__assign)((0, tslib_1.__assign)({}, result2), { savePaymentToken: savePaymentToken_1, name: values.paymentDetails.cardName }), cardType);
                                                completeStep(currentStepKey);
                                                setLoading(false);
                                                goToStep(nextStepKey);
                                            }
                                        });
                                    }
                                });
                            }
                            catch (e) {
                                setLoading(false);
                            }
                        }
                        else {
                            if (savedPaymentCardDetails) {
                                onSubmit(savedPaymentCardDetails, cardType);
                            }
                            completeStep(currentStepKey);
                            setLoading(false);
                            goToStep(nextStepKey);
                        }
                    }
                }
            }
        }),
            react_1.default.createElement(asg_1.Box, { margin: {
                    horizontal: responsiveSize === 'xs' ? 'none' : 'xsmall'
                } },
                react_1.default.createElement(asg_1.Heading, { level: 4, weight: 700 }, "Payment details"),
                react_1.default.createElement(asg_1.Box, { margin: {
                        top: responsiveSize === 'xs' ? 'xsmall' : 'medium',
                        bottom: 'none'
                    } },
                    accountDetails && react_1.default.createElement(components_1.AccountCard, (0, tslib_1.__assign)({}, accountDetails)),
                    react_1.default.createElement(components_1.PaymentAmount, { disabled: loading, ga: ga })),
                !hasSavedPaymentError && (react_1.default.createElement(asg_1.Box, { margin: {
                        top: 'large'
                    } },
                    react_1.default.createElement(asg_1.Heading, { level: "3", weight: 700 }, "Payment method"))),
                savedPayment && (react_1.default.createElement(asg_1.Box, null,
                    react_1.default.createElement(SavedPaymentTile_1.default, { customerNumber: savedPayment.customerNumber, paymentFilter: SavedPaymentTile_types_1.SavedPaymentType.CARD, selectedAccountId: selectedPaymentMethod, radioGroupName: exports.SECTION_KEY + ".savePaymentId", onChange: function (selectedOption, savedPaymentData) {
                            var _a, _b;
                            if (((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.payment') {
                                ga === null || ga === void 0 ? void 0 : ga.push(selectedOption === SavedPaymentTile_1.ADD_NEW ? 'click.3.newcardcapture' : 'click.3.savedcardcapture');
                            }
                            if (selectedOption === SavedPaymentTile_1.ADD_NEW) {
                                setSelectedPaymentMethod(SavedPaymentTile_1.ADD_NEW);
                                setFieldValue(exports.SECTION_KEY + ".savedPaymentId", '');
                                setIsCardValid(true);
                                setGoToBambora(true);
                                setFieldValue(exports.SECTION_KEY + ".selectedOption", SavedPaymentTile_1.ADD_NEW);
                            }
                            else {
                                setFieldValue(exports.SECTION_KEY + ".savedPaymentId", savedPaymentData === null || savedPaymentData === void 0 ? void 0 : savedPaymentData.savedPaymentId);
                                setIsCardValid(true);
                                if (savedPaymentData) {
                                    setSelectedPaymentMethod(savedPaymentData.savedPaymentId);
                                    if (savedPaymentData.ccDetails)
                                        setSavedPaymentCardDetails({
                                            last4: savedPaymentData.ccDetails.number.substring(savedPaymentData.ccDetails.number.length - 4, savedPaymentData.ccDetails.number.length),
                                            expiryMonth: savedPaymentData.ccDetails.expiry.substring(5, 7),
                                            expiryYear: savedPaymentData.ccDetails.expiry.substring(0, 4),
                                            code: 0,
                                            token: '',
                                            name: (_b = savedPaymentData.ccDetails) === null || _b === void 0 ? void 0 : _b.name,
                                            tokenType: types_2.TokenType.STT,
                                            savedPaymentId: savedPaymentData.savedPaymentId
                                        });
                                    setFieldValue(exports.SECTION_KEY + ".selectedOption", 'card');
                                }
                                setGoToBambora(false);
                            }
                        }, setLoading: function () {
                            setLoading(false);
                            setSavedAccountLoading(false);
                        }, onError: function () { return setSavedPaymentError(true); } }))),
                selectedPaymentMethod === SavedPaymentTile_1.ADD_NEW && showCC && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(asg_1.Heading, { level: "3", margin: { top: '32px', bottom: 'xsmall' }, weight: 700 }, "Card details"),
                    react_1.default.createElement(components_1.CreditCard, { sectionKey: exports.SECTION_KEY, instance: instance, onError: function () {
                            if (selectedPaymentMethod === SavedPaymentTile_1.ADD_NEW)
                                setIsCardValid(false);
                        }, onComplete: function (cardType) {
                            setIsCardValid(true);
                            setCardType(cardType);
                        }, disabled: loading }))),
                savedPayment && showCC && selectedPaymentMethod === SavedPaymentTile_1.ADD_NEW && (react_1.default.createElement(PaymentMethodCheckBox_1.default, { ga: ga, baseUrl: appBaseUrl, visiblePrivacyMessage: values.paymentDetails.hasSavePaymentMethod })),
                savedPayment && !savedAccountLoading && (react_1.default.createElement(asg_1.Box, null,
                    react_1.default.createElement(PaypalPaymentTile_1.default, { ga: ga, selectedAccountId: selectedPaymentMethod, radioGroupName: exports.SECTION_KEY + ".paypal", onChange: function (selectedOption) {
                            if (selectedOption === PaypalPaymentTile_2.PAYPAL) {
                                setSelectedPaymentMethod(PaypalPaymentTile_2.PAYPAL);
                                setFieldValue(exports.SECTION_KEY + ".PAYPAL", '');
                                setIsCardValid(true);
                                setGoToBambora(false);
                                setFieldValue(exports.SECTION_KEY + ".savedPaymentId", '');
                                setFieldValue(exports.SECTION_KEY + ".selectedOption", PaypalPaymentTile_2.PAYPAL);
                            }
                        } }))))));
    }
    return null;
};
exports.Authenticated = Authenticated;
exports.default = exports.Authenticated;
//# sourceMappingURL=Authenticated.js.map